<template>
  <section
    class="max-w-screen-2xl mx-auto mt-12 mb-20 px-8 text-left sm:mt-20 xl:flex"
  >
    <section class="mb-16 xl:mt-4 xl:mr-16 xl:w-1/4">
      <article class="mb-8">
        <h3 class="h3-title">{{ video.date }}</h3>
        <p>{{ video.time }} CEST</p>
        <div v-if="contactLink" class="mt-2">
          <BaseButton :href="contactLink.url" :blank="true">
            {{ contactLink.text }}
          </BaseButton>
        </div>
      </article>

      <article v-if="video.related_content.length">
        <h3 class="h3-title mb-2">Recursos Adicionales</h3>

        <div>
          <div v-for="item in video.related_content" :key="item.pk">
            <a
              v-if="video.available"
              :href="getUrl(item)"
              target="_blank"
              class="inline-block text-secondary-500 hover:underline"
            >
              {{ item.title }}
            </a>
            <span v-else class="text-secondary-500">{{ item.title }}</span>
          </div>
        </div>
      </article>
    </section>

    <section class="xl:w-3/4">
      <article>
        <h1 class="text-3xl md:text-5xl">
          <strong>{{ video.title }}</strong>
        </h1>

        <h2 class="text-xl pl-2 md:text-2xl">{{ video.section }}</h2>

        <div v-if="video" class="py-4">
          <VideoSocial />
        </div>
      </article>

      <article class="pl-2 pt-2 text-main-400">
        <span v-for="tag in video.tags" :key="tag.key" class="p-1">
          {{ tag.tag }}
        </span>
      </article>

      <article v-if="!video.available" class="flex mt-4 ml-3">
        <div class="text-red-500 font-bold">
          Disponible<span v-if="!video.available">
            el {{ video.date }} a las {{ video.time }}</span
          >
        </div>
      </article>

      <article class="description">
        <!-- eslint-disable-next-line vue/no-v-html -->
        <p v-html="video.description" />
      </article>

      <section class="mt-12 lg:flex lg:flex-wrap lg:flex-shrink">
        <SpeakersListItem
          v-for="speaker in video.speakers"
          :key="speaker.pk"
          :speaker="speaker"
        />
      </section>
    </section>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import SpeakersListItem from '@/components/SpeakersListItem'
import VideoSocial from '@/components/VideoSocial'

export default {
  components: { SpeakersListItem, VideoSocial },

  props: {
    video: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapState('videos', ['contactLink']),
  },

  methods: {
    getUrl(item) {
      if (item.content_type === 'documento') {
        return item.document
      } else if (item.content_type === 'enlace-externo') {
        return item.external_url
      }
    },
  },
}
</script>

<style scoped>
.description {
  @apply mt-12;
}

.h3-title {
  @apply text-lg font-bold;
}
</style>
